module.exports = __webpack_public_path__ + "b10f0179922bca4196918ef5f88a802a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-1080.jpg
// module id = 423
// module chunks = 0